import state from "@/store/modules/inventorie/state";
import actions from "@/store/modules/inventorie/actions";
import mutations from "@/store/modules/inventorie/mutations";
import getters from "@/store/modules/inventorie/getters";

export default {
  state,
  actions,
  mutations,
  getters
}